module.exports = __webpack_public_path__ + "public/img/grey-share.e6d5e69c.png";